export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <path
      d="M32 7 L53 19.5 v25 L32 57 L11 44.5 v-25 Z"
      stroke="#24A0F7"
      strokeWidth="3.4"
      fill="rgba(36,160,247,0.08)"
    />
    <path d="M35.5 14 L21.5 35.5 h8.5 L27.5 51 L43 29.5 h-9.5 Z" fill="#24A0F7" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2 sm:gap-3">
    <LogoMark />
    {!compact && (
      <span className="leading-none">
        <span className="font-display block text-[12px] font-bold tracking-wide text-[var(--ink)] sm:text-[15px]">
          THIONNET SERVICE INDUSTRIE
        </span>
        <span className="mt-1 block text-[9px] font-mono uppercase tracking-[0.22em] text-[var(--accent-text)] sm:text-[10px] sm:tracking-[0.28em]">
          Portail Client CEE
        </span>
        <span className="mt-1 block text-[9px] text-[var(--mute)]">
          by Genis
        </span>
      </span>
    )}
  </span>
);

/* Favicon : monogramme « G » encadré (Genis) — voir public/favicon.svg */
